import type { TFunction } from "i18next"

// Our API's refusals are written for customers. Anything else that was thrown is a bug or
// a browser failure, whose text isn't.
export const errorText = (error: unknown, t: TFunction): string =>
  error instanceof Error && error.name === "SowApiError"
    ? error.message
    : String(t("aiCenter.sowReceivables.common.unexpectedError"))
